import ProgrammeImage2 from "../../../../../assets/images/png/courses/international/programme2.webp";
import SchoolImage from "../../../../../assets/images/png/school/international/white-woman.webp";

export const productSchoolDataEurope = {
  tag: "Product",
  id: "productSchool",
  url: "/product-school",
  image: SchoolImage,

  name: "Product School",
  description: `The Utiva Product School offers leading practices in product management and
  product prototyping through an experiential learning process.`,
  keywords: `product management,  product management training, product management school, product manager training, product manager school, product management certification, product school`,
  metatags: `Become a product manager in 1 month. Learn from the largest product school in Nigeria. Take the most practical product management training.`,

  courses: [
    {
      id: 1,
      courseImage: ProgrammeImage2,
      courseName: "Product Management Bootcamp",
      courseDescription: `
      This intensive training takes on a practical approach to helping you move from a 
      junior PM or accidental product manager to a senior product manager who is ready to build world class product. 
    `,
      courseStartDate: "December 2, 2023",

      courseDuration: "12 Weeks",

      courseTags: ["For Professionals"],

      courseUrl: "/product-management-bootcamp",

      enrolUrl: "https://flutterwave.com/pay/utivapma-full",
    },
  ],

  testimony: {
    // testimonierImage: `https://res.cloudinary.com/codeg0d/image/upload/v1624419471/tola_f0enbn.jpg`,
    testimonierName: "Olasunkanmi Adetola",
    testimonierTitle: "Product School",
    testimonyDescription: `I took a the product management course at Utiva last year and with the right mentoring and support, I transitioned with a non-tech background into a full time product management role in a tech company. I really appreciate the learning process at Utiva.`,
  },

  article: [],

  careerTitle: "Product Manager",

  careerPaths: [
    "Associate Product manager",
    "Product Manager",
    "Senior product manager",
    "Director of Product",
    "VP Product",
    "Chief Product Officer",
  ],

  quickFactSalary: "$113,501",

  quickFacts: [
    "Product Management has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum.",
  ],
};
